module.exports = __webpack_public_path__ + "img/1533740035.e0a19d01.jpg";